module.exports = __webpack_public_path__ + "img/13-twoImg.3f5ac87d.png";